'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_group_report', {
        template: '<monthly-group-report></monthly-group-report>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/group_report/monthly/monthly_group_report.routes.js